// extracted by mini-css-extract-plugin
export var animatedDesktop = "WhatWeDoCard-module--animatedDesktop--39a95";
export var card = "WhatWeDoCard-module--card--c3f28";
export var content = "WhatWeDoCard-module--content--5578b";
export var description = "WhatWeDoCard-module--description--a03f5";
export var fadeInAnimation = "WhatWeDoCard-module--fadeInAnimation--e780b";
export var link = "WhatWeDoCard-module--link--6d638";
export var linkWrapper = "WhatWeDoCard-module--linkWrapper--fb5aa";
export var list = "WhatWeDoCard-module--list--be73f";
export var title = "WhatWeDoCard-module--title--62500";
export var titleWrapper = "WhatWeDoCard-module--titleWrapper--2aaf1";